function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46892",
    d: "M17.2 5H2.8a.8.8 0 1 0 0 1.6h1.6v9.6a2.4 2.4 0 0 0 2.4 2.4h6.4a2.4 2.4 0 0 0 2.4-2.4V6.6h1.6a.8.8 0 0 0 0-1.6zm-8 8.8a.8.8 0 1 1-1.6 0v-4a.8.8 0 1 1 1.6 0zm3.2 0a.8.8 0 1 1-1.6 0v-4a.8.8 0 1 1 1.6 0z",
    transform: "translate(-2 -2.6)",
    style: {
      fill: "#f0483e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46893",
    d: "M9.8 3.6H13A.8.8 0 1 0 13 2H9.8a.8.8 0 1 0 0 1.6z",
    transform: "translate(-3.4 -2)",
    style: {
      fill: "#f0483e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconTable);
export default __webpack_public_path__ + "static/media/DeleteIconTable.ac74e7a9f50a49caede5033a9ab1729e.svg";
export { ForwardRef as ReactComponent };